import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { SharedModule } from "lib-trend-core";
import { CrmComponent } from "./crm.component";
import { CrmRoutingModule } from "./crm.routing.module";
import { NgxChartsModule } from "@swimlane/ngx-charts";

@NgModule({
  imports: [SharedModule, CrmRoutingModule, NgxChartsModule,],
  declarations: [CrmComponent],
  exports: [CrmComponent],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CrmModule { }
